import React, { useEffect, useState } from "react";
import PostApiCall from "../../Api/Api";
import moment from "moment";
import Notiflix from "notiflix";
import { ToastContainer, toast } from "react-toastify";
import {
  CandidateAlreadyRegitered,
  SomethingWrong,
} from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import logo from "../../assets/profile/login.jpg";
import Select from "react-select";
import { Eye, EyeOff, Key, Mail, Smartphone, User } from "react-feather";
import { GoogleLogin, GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import jwt from "jsonwebtoken";
import CommonModal from "../../Components/CommonModal";
import { fetchData } from "../../Store/Actions/LoginAction";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const Register = ({ refercode }) => {
  const [EmailRegex] = useState(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  const [ShowPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [NumRegex] = useState(/^[6-9]\d{9}$/);
  const [showConfirmPassEye, setShowConfirmPassEye] = useState(false);
  const [passwordModal, setPassModal] = useState(false);
  const [user, setUser] = useState({
    Name: "",
    Email: "",
    Mobile: "",
    Pass: "",
    Confirm_Pass: "",
    RegisterType: "",
    isAccept: false,
  });


  const onVerifyClicked = () => {
    const payload = {
      name: user.Name.toLowerCase(),
      email: user.Email.toLowerCase(),
      mobile: user.Mobile,
      password: user.Pass,
      // usertype: user.RegisterType,
      usertype: "Seeker",
      updatedon: moment().format("ll"),
      addedon: moment().format("ll"),
      emailverify: "No",
      refercode: refercode || "",
      flag: false,
    };

    const isValid = validateForm();

    if (isValid) {
      Notiflix.Loading.standard();
      PostApiCall.postRequest(payload, "RegisterCandidate").then((resultdes) =>
        resultdes
          .json()
          .then((obj) => {
            if (resultdes.status === 200) {
              GenerateOTP(user.Email);
            } else {
              if (obj.error === "Email already exists.") {
                Notiflix.Loading.remove();
                toast.error(CandidateAlreadyRegitered, {
                  autoClose: delay,
                  toastId: 1,
                });
              } else {
                Notiflix.Loading.remove();
                toast.error(obj.error || SomethingWrong, {
                  autoClose: delay,
                  toastId: 1,
                });
              }
            }
          })
          .catch((err) => {
         
            Notiflix.Loading.remove();
            toast.error(err.message, {
              autoClose: delay,
              toastId: 1,
            });
          })
      );
    }
    // if (!user.RegisterType) {
    //   toast.error("Please select user type", { autoClose: delay });
    //   return;
    // }
    // if (!user.Name) {
    //   toast.error("Please enter a name", { autoClose: delay });
    //   return;
    // }

    // if (!EmailRegex.test(String(user.Email).toLowerCase())) {
    //   toast.error("Please enter a valid email address", { autoClose: delay });
    //   return;
    // }

    // if (!user.Mobile) {
    //   toast.error("Please enter a nontact number", { autoClose: delay });
    //   return;
    // }
    // if (!user.Pass) {
    //   toast.error("Please enter a password", { autoClose: delay });
    //   return;
    // }
    // if (user.Pass !== user.Confirm_Pass) {
    //   toast.error("Passwords do not match", { autoClose: delay });
    //   return;
    // }
  };

  const GenerateOTP = (name) => {
    PostApiCall.postRequest(
      {
        name: name,
        updatedat: moment().format("MMM DD, YYYY h:mm A"),
      },
      "GenerateOTP"
    )
      .then((result) => {
        // Handle the response from the verification API
        if (!result.ok) {
          throw new Error("Failed to fetch data");
        }

        Notiflix.Loading.remove();

        toast.success("OTP has been sent to your email", {
          autoClose: delay,
        });
        history.push("/verifyemail", {
          name: name,
          password: user.Pass,
        });
      })
      .catch((error) => {
        Notiflix.Loading.remove();

        console.error("Error verifying email:", error);
      });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    // if (!user.RegisterType) {
    //   newErrors.RegisterType = "User type is required";
    // }
    if (!user.Name) {
      newErrors.Name = "Name is required";
    }

    if (!user.Email === "") {
      newErrors.Email = "Email address is required";
    } else {
      if (!EmailRegex.test(String(user.Email).toLowerCase())) {
        newErrors.Email = "Invalid email address";
      }
    }

    if (!user.Mobile) {
      newErrors.Mobile = "Contact is required";
    } else {
      if (!NumRegex.test(user.Mobile)) {
        newErrors.Mobile = "Invalid number";
      }
    }
    if (!user.Pass) {
      newErrors.Pass = "Password is required";
    }

    if (user.Pass !== user.Confirm_Pass) {
      newErrors.Confirm_Pass = "Passwords do not match";
    }
    if (!user.isAccept) {
      newErrors.isAccept = "Accept the terms and conditions to proceed";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };



  const AuthSubmit = async () => {
    
    const isValid = validateForm();
    if (isValid) {
      try {
        Notiflix.Loading.standard();
        setPassModal(false);
        const payload = {
          name: user?.Name?.toLowerCase(),
          email: user?.Email?.toLowerCase(),
          password: user?.Pass,
          mobile: user?.Mobile,
          usertype: "Seeker",
          updatedon: moment().format("ll"),
          addedon: moment().format("ll"),
          emailverify: "Yes",
          refercode: refercode || "",
          flag: false,
        };

        // Make the API request
        const resultdes = await PostApiCall.postRequest(
          payload,
          "RegisterCandidate"
        );
        const obj = await resultdes.json();

        if (resultdes.status === 200 || resultdes.status === 201) {
          const payload = {
            email: user?.Email?.toLowerCase(),
            password: user.Pass,
            isauth: true,
          };
          const method = "POST";
          const url = "CheckIfJobUserExists";

          // Dispatch the fetchData action
          const userExist = await dispatch(fetchData(payload, method, url));

          if (userExist) {
            history.push("/account");
          }
        } else if (obj.error === "Email already exists.") {
          Notiflix.Loading.remove();
          toast.error(CandidateAlreadyRegitered, {
            autoClose: delay,
            toastId: 1,
          });
        } else {
          
          Notiflix.Loading.remove();
          toast.error(obj.error || SomethingWrong, {
            autoClose: delay,
            toastId: 1,
          });
        }
      } catch (err) {
        console.error(err);
        setPassModal(false);
        Notiflix.Loading.remove();
        toast.error(err.message || SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      } finally {
       
        setUser({
          Name: "",
          Email: "",
          Mobile: "",
          Pass: "",
          Confirm_Pass: "",
          RegisterType: "",
          isAccept: false,
        });
        Notiflix.Loading.remove();
      }
      
    }
  };

  const GoogleIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="20px"
      height="20px"
    >
      <path
        fill="#EA4335"
        d="M24 9.5c3.67 0 6.97 1.41 9.42 3.69L39.66 6.5C35.5 2.85 30.02 0 24 0 14.87 0 7.1 5.29 3.56 12.93l8.4 6.6C13.61 13.59 18.48 9.5 24 9.5z"
      />
      <path
        fill="#34A853"
        d="M46.13 24.5c0-1.5-.13-2.95-.37-4.34H24v8.19h12.45c-.53 2.76-2.13 5.1-4.58 6.65v5.38h7.41c4.33-4 6.85-9.93 6.85-15.88z"
      />
      <path
        fill="#4A90E2"
        d="M11.96 28.45c-.57-1.32-.9-2.74-.9-4.26s.33-2.94.91-4.26l-8.41-6.6C1.2 16.77 0 20.25 0 24s1.2 7.23 3.56 10.41l8.4-6.6z"
      />
      <path
        fill="#FBBC05"
        d="M24 48c6.02 0 11.5-2.05 15.31-5.56l-7.4-5.38c-2.11 1.41-4.79 2.24-7.91 2.24-5.52 0-10.38-4.09-12.04-9.51l-8.4 6.6C7.1 42.72 14.87 48 24 48z"
      />
      <path fill="none" d="M0 0h48v48H0z" />
    </svg>
  );

  const GoogleLoginButton = () => {
    const handleGoogleLogin = useGoogleLogin({
      onSuccess: async (response) => {
        try {
          // Fetch user info using the access token
          const userInfoResponse = await fetch(
            'https://www.googleapis.com/oauth2/v3/userinfo',
            {
              headers: {
                Authorization: `Bearer ${response.access_token}`,
              },
            }
          );
          if (!userInfoResponse.ok) {
            throw new Error('Failed to fetch user info');
          }
          const userInfo = await userInfoResponse.json();

          // check User Already login or not

          const payload = {
            email: userInfo.email,
            isauth: true,
            isReg:true
          };

          const method = "POST";
          const url = "CheckIfJobUserExists";

          // Dispatch the fetchData action
          const userExist = await dispatch(fetchData(payload, method, url));
         
          if (userExist) {
            history.push("/account");
          } else {
            const userData = {
              Email: userInfo.email,
              Name: userInfo.name,
              isAccept: true,
            };
            setUser((pre) => ({
              ...pre,
              ...userData,
            }));

            setPassModal(true);
          }
        } catch (error) {
          console.error('Error fetching user info:', error);
          toast.error('Failed to fetch user information');
        }
      },
      onError: (error) => {
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      },
    });

    return (
      <button
        className="d-flex align-items-center justify-content-center w-100 py-2 bg-white"
        style={{
          borderRadius: 10,
          border: "1px solid #ccc",
          cursor: "pointer",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={handleGoogleLogin} // Opens Google login popup
      >
        <GoogleIcon />
        <p className="ml-2" style={{ color: "#595959", fontWeight: "500", margin: 0 }}>
          Sign up with Google
        </p>
      </button>
    );
  };


  return (
    <div
      className="bg-light d-flex justify-content-center align-items-center p-md-5 mt-5"
      style={{ height: "100vh" }}
    >
      <ToastContainer />
      <Row className="d-flex justify-content-center shadow bg-white ">
        <Col className="d-none d-md-block my-auto">
          <img src={logo} width={"400px"} height={"500px"} />
        </Col>
        <Col>
          <div className="page-login-form px-2 py-4">
            <h3>Create Your account</h3>

            <form
              className="login-form"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="form-group mb-0">
                <div className="input-icon">
                  <i style={{ zIndex: 10 }}>
                    <User size={15} />
                  </i>
                  <input
                    type="text"
                    value={user.Name}
                    onChange={(e) => {
                      setUser({ ...user, Name: e.target.value });
                      setErrors((prev) => ({
                        ...prev,
                        Name: "",
                      }));
                    }}
                    style={{ textTransform: "capitalize" }}
                    className="form-control"
                    placeholder="Full Name"
                  />
                </div>
                <p
                  style={{
                    width: "100%",

                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.Name}
                </p>
              </div>
              <div className="form-group my-2">
                <div className="input-icon">
                  <i style={{ zIndex: 10 }}>
                    <Mail size={15} />
                  </i>
                  <input
                    type="email"
                    value={user.Email.toLowerCase()}
                    onChange={(e) => {
                      setUser({ ...user, Email: e.target.value });
                      setErrors((prev) => ({
                        ...prev,
                        Email: "",
                      }));
                    }}
                    className="form-control"
                    placeholder="Email Address"

                    // style={{ textTransform: "lowercase" }}
                  />
                </div>
                <p
                  style={{
                    width: "100%",

                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.Email}
                </p>
              </div>
              <div className="form-group mb-0">
                <div className="input-icon">
                  <i>
                    <Smartphone size={15} />
                  </i>
                  <input
                    type="text"
                    maxLength={10} // Restrict length to 10 digits
                    value={user.Mobile}
                    onKeyDown={(e) => {
                      // Prevent non-numeric keys
                      if (
                        !/[0-9]/.test(e.key) && // Allow numbers
                        e.key !== "Backspace" && // Allow backspace
                        e.key !== "Delete" && // Allow delete
                        e.key !== "ArrowLeft" && // Allow left arrow
                        e.key !== "ArrowRight" && // Allow right arrow
                        e.key !== "Tab" // Allow tab
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onInput={(e) => {
                      // Prevent leading zeros and keep only digits
                      const sanitizedValue = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 10);
                      setUser({ ...user, Mobile: sanitizedValue });
                    }}
                    onChange={() => {
                      // Optional: Ensure consistent state updates
                      setErrors((prev) => ({
                        ...prev,
                        Mobile: "",
                      }));
                    }}
                    className="form-control"
                    placeholder="Mobile Number"
                  />
                </div>

                <p
                  style={{
                    width: "100%",

                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.Mobile}
                </p>
              </div>

              <div className="form-group  my-2">
                <div className="input-icon">
                  <i>
                    <Key size={15} />
                  </i>
                  <input
                    type={ShowPassword ? "text" : "password"}
                    value={user.Pass}
                    onChange={(e) => {
                      setUser({ ...user, Pass: e.target.value });
                      setErrors((prev) => ({
                        ...prev,
                        Pass: "",
                      }));
                      setShowConfirmPass(true);
                    }}
                    className="form-control"
                    placeholder="Create your Password"
                  />
                  {ShowPassword ? (
                    <Eye
                      size={15}
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        marginRight: "10px",
                        marginTop: "15px",
                      }}
                      onClick={() => setShowPassword(!ShowPassword)}
                    />
                  ) : (
                    <EyeOff
                      size={15}
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        marginRight: "10px",
                        marginTop: "15px",
                      }}
                      onClick={() => setShowPassword(!ShowPassword)}
                    />
                  )}
                </div>
                <p
                  style={{
                    width: "100%",

                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.Pass}
                </p>
              </div>
              {showConfirmPass && (
                <div className="form-group mb-0">
                  <div className="input-icon">
                    <i>
                      <Key size={15} />
                    </i>
                    <input
                      type={showConfirmPassEye ? "text" : "password"}
                      value={user.Confirm_Pass}
                      onChange={(e) => {
                        setUser({ ...user, Confirm_Pass: e.target.value });
                        setErrors((prev) => ({
                          ...prev,
                          Confirm_Pass: "",
                        }));
                      }}
                      className="form-control"
                      placeholder="Confirm Password"
                    />
                    {showConfirmPassEye ? (
                      <Eye
                        size={15}
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          marginRight: "10px",
                          marginTop: "15px",
                        }}
                        onClick={() =>
                          setShowConfirmPassEye(!showConfirmPassEye)
                        }
                      />
                    ) : (
                      <EyeOff
                        size={15}
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          marginRight: "10px",
                          marginTop: "15px",
                        }}
                        onClick={() =>
                          setShowConfirmPassEye(!showConfirmPassEye)
                        }
                      />
                    )}
                  </div>
                  <p
                    style={{
                      width: "100%",

                      fontSize: "80%",
                      color: "#dc3545",
                    }}
                  >
                    {errors.Confirm_Pass}
                  </p>
                </div>
              )}
              <div className="form-group mt-3">
                <FormGroup check inline>
                  <Input
                    type="checkbox"
                    value={user.isAccept}
                    onChange={(e) => {
                      setUser({ ...user, isAccept: e.target.checked });
                      setErrors((prev) => ({
                        ...prev,
                        isAccept: false,
                      }));
                    }}
                  />
                  <Label check className="ml-2" style={{ fontSize: "11px" }}>
                    I agree with{" "}
                    <a
                      href="/terms-condition"
                      style={{ cursor: "pointer" }}
                      target="__blank"
                    >
                      {" "}
                      terms & conditions
                    </a>
                  </Label>
                </FormGroup>
                <p
                  style={{
                    width: "100%",

                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.isAccept}
                </p>
              </div>
              <button
                className="btn btn-common log-btn mb-0"
                style={{ borderRadius: 10 }}
                onClick={onVerifyClicked}
              >
                Submit
              </button>
            </form>
            <p
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
              className="my-2"
            >
              <hr
                style={{
                  flex: 1,
                  border: "none",
                  borderTop: "1px solid #ccc",
                  margin: "0 10px",
                }}
              />
              <Label style={{ fontSize: "11px" }}>Or</Label>
              <hr
                style={{
                  flex: 1,
                  border: "none",
                  borderTop: "1px solid #ccc",
                  margin: "0 10px",
                }}
              />
            </p>

            <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
              {/* Google Login Button */}
             <GoogleLoginButton/>
            </GoogleOAuthProvider>
            {/* <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                    <GoogleIcon />
                    </div> */}

            <p className="text-center mt-2" style={{ fontSize: "12px" }}>
              Already have an account ?
              <span
                style={{ cursor: "pointer" }}
                className="baseTextColor"
                onClick={() => history.push("/login")}
              >
                {" "}
                Login
              </span>
            </p>
          </div>
        </Col>
      </Row>

      <CommonModal
        isOpen={passwordModal}
        toggle={() => setPassModal(!passwordModal)}
        heading={"Create Your Password"}
        onConfirm={AuthSubmit}
        contentBody={
          <div className="page-login-form px-2 py-4">
            <form
              className="login-form"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="form-group mb-0">
                <div className="input-icon">
                  <i>
                    <Smartphone size={15} />
                  </i>
                  <input
                    type="text"
                    maxLength={10} // Restrict length to 10 digits
                    value={user.Mobile}
                    onKeyDown={(e) => {
                      // Prevent non-numeric keys
                      if (
                        !/[0-9]/.test(e.key) && // Allow numbers
                        e.key !== "Backspace" && // Allow backspace
                        e.key !== "Delete" && // Allow delete
                        e.key !== "ArrowLeft" && // Allow left arrow
                        e.key !== "ArrowRight" && // Allow right arrow
                        e.key !== "Tab" // Allow tab
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onInput={(e) => {
                      // Prevent leading zeros and keep only digits
                      const sanitizedValue = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 10);
                      setUser({ ...user, Mobile: sanitizedValue });
                    }}
                    onChange={() => {
                      // Optional: Ensure consistent state updates
                      setErrors((prev) => ({
                        ...prev,
                        Mobile: "",
                      }));
                    }}
                    className="form-control"
                    placeholder="Mobile Number"
                  />
                </div>

                <p
                  style={{
                    width: "100%",

                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.Mobile}
                </p>
              </div>
              <div className="form-group  my-2">
                <div className="input-icon">
                  <i>
                    <Key size={15} />
                  </i>
                  <input
                    type={ShowPassword ? "text" : "password"}
                    value={user.Pass}
                    onChange={(e) => {
                      setUser({ ...user, Pass: e.target.value });
                      setErrors((prev) => ({
                        ...prev,
                        Pass: "",
                      }));
                      setShowConfirmPass(true);
                    }}
                    className="form-control"
                    placeholder="Create your Password"
                  />
                  {ShowPassword ? (
                    <Eye
                      size={15}
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        marginRight: "10px",
                        marginTop: "15px",
                      }}
                      onClick={() => setShowPassword(!ShowPassword)}
                    />
                  ) : (
                    <EyeOff
                      size={15}
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        marginRight: "10px",
                        marginTop: "15px",
                      }}
                      onClick={() => setShowPassword(!ShowPassword)}
                    />
                  )}
                </div>
                <p
                  style={{
                    width: "100%",

                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.Pass}
                </p>
              </div>
              {showConfirmPass && (
                <div className="form-group mb-0">
                  <div className="input-icon">
                    <i>
                      <Key size={15} />
                    </i>
                    <input
                      type={showConfirmPassEye ? "text" : "password"}
                      value={user.Confirm_Pass}
                      onChange={(e) => {
                        setUser({ ...user, Confirm_Pass: e.target.value });
                        setErrors((prev) => ({
                          ...prev,
                          Confirm_Pass: "",
                        }));
                      }}
                      className="form-control"
                      placeholder="Confirm Password"
                    />
                    {showConfirmPassEye ? (
                      <Eye
                        size={15}
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          marginRight: "10px",
                          marginTop: "15px",
                        }}
                        onClick={() =>
                          setShowConfirmPassEye(!showConfirmPassEye)
                        }
                      />
                    ) : (
                      <EyeOff
                        size={15}
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          marginRight: "10px",
                          marginTop: "15px",
                        }}
                        onClick={() =>
                          setShowConfirmPassEye(!showConfirmPassEye)
                        }
                      />
                    )}
                  </div>
                  <p
                    style={{
                      width: "100%",

                      fontSize: "80%",
                      color: "#dc3545",
                    }}
                  >
                    {errors.Confirm_Pass}
                  </p>
                </div>
              )}
                <div className="form-group mt-3">
                <FormGroup check inline>
                  <Input
                    type="checkbox"
                    value={user.isAccept}
                    onChange={(e) => {
                      setUser({ ...user, isAccept: e.target.checked });
                      setErrors((prev) => ({
                        ...prev,
                        isAccept: false,
                      }));
                    }}
                  />
                  <Label check className="ml-2" style={{ fontSize: "11px" }}>
                    I agree with{" "}
                    <a
                      href="/terms-condition"
                      style={{ cursor: "pointer" }}
                      target="__blank"
                    >
                      {" "}
                      terms & conditions
                    </a>
                  </Label>
                </FormGroup>
                <p
                  style={{
                    width: "100%",

                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.isAccept}
                </p>
              </div>
            </form>
          </div>
        }
        confirmText={"submit"}
        cancelText={"Cancel"}
        onCancel={() => setPassModal(false)}
      />
    </div>
  );
};

export default Register;

{
  /* <div className="form-group mb-3">
                <div
                  className="input-icon w-100"
                  style={{ borderRadius: 10, zIndex: 20 }}
                >
                  <Select
                    className="React"
                    classNamePrefix="select "
                    name="color"
                    placeholder="Register as.."
                    value={registerType}
                    options={[
                      { value: "Seeker", label: "Employee" },
                      { value: "Recruiter", label: "Employer" },
                    ]}
                    onChange={(e) => {
                      setUser({ ...user, RegisterType: e.value });
                      setErrors((prev) => ({
                        ...prev,
                        RegisterType: "",
                      }));
                    }}
                    
                  />
                </div>
                <p style={{
                          width: "100%",
                        
                          fontSize: "80%",
                          color: "#dc3545",
                        }}>{errors.RegisterType}</p>
              </div> */
}
